import React from "react";
import "./WorkflowTimeline.css";

function WorkflowTimeline() {
  return (
    <div className="workflow-timeline">
      <div className="workflow-step">
        <div className="workflow-icon">1</div>
        <div className="workflow-detail">
          <h4>Erste Umfrage</h4>
          <p>
            Antworten Sie auf Fragen zu Ihren Erwartungen und zur Wartezeit.
          </p>
        </div>
      </div>
      <div className="workflow-step">
        <div className="workflow-icon">2</div>
        <div className="workflow-detail">
          <h4>Memory-Spiel</h4>
          <p>
            Spielen Sie ein Memory-Spiel, um die Wartezeit interaktiv zu überbrücken.
          </p>
        </div>
      </div>
      <div className="workflow-step">
        <div className="workflow-icon">3</div>
        <div className="workflow-detail">
          <h4>Endumfrage</h4>
          <p>
            Geben Sie abschließend Feedback zu Ihrer Wartezeiterfahrung.
          </p>
        </div>
      </div>
    </div>
  );
}

export default WorkflowTimeline;